<template>
  <div v-if="shouldShow" class="form-field" :class="[`form-field--span-${field.span || 1}`, { 'form-field--required': field.required }]">
    <label class="form-label">
      {{ field.label }}
      <span v-if="field.required" class="required-indicator">*</span>
    </label>

    <!-- Text Input -->
    <input
      v-if="['text', 'email', 'tel'].includes(field.type)"
      :type="field.type"
      class="form-control"
      :value="form[field.key]"
      @input="updateValue($event.target.value)"
      :readonly="!canEdit || field.readonly"
      :placeholder="field.placeholder"
    />

    <!-- Date Input -->
    <input
      v-else-if="field.type === 'date'"
      type="date"
      class="form-control"
      :value="form[field.key]"
      @input="updateValue($event.target.value)"
      :readonly="!canEdit || field.readonly"
    />

    <!-- Textarea -->
    <textarea
      v-else-if="field.type === 'textarea'"
      class="form-control"
      :value="form[field.key]"
      @input="updateValue($event.target.value)"
      :readonly="!canEdit || field.readonly"
      :rows="field.rows || 3"
      :placeholder="field.placeholder"
    />

    <!-- Select -->
    <select
      v-else-if="field.type === 'select'"
      class="form-control"
      :value="form[field.key]"
      @change="updateValue($event.target.value)"
      :disabled="!canEdit || field.readonly"
    >
      <option value="">Please select...</option>
      <option v-for="option in field.options" :key="option.value" :value="option.value">
        {{ option.label }}
      </option>
    </select>

    <!-- School Select -->
    <select
      v-else-if="field.type === 'school-select'"
      class="form-control"
      :value="form[field.key]"
      @change="updateValue($event.target.value)"
      :disabled="!canEdit || field.readonly"
    >
      <option value="">Please select...</option>
      <option v-for="school in schoolList" :key="school.SchoolID" :value="school.SchoolID">
        {{ school.SchoolName }}
        <template v-if="school.SchoolID === 'SCH201500000043' || school.SchoolID === 'SCH201400000537'"> (Pre-School) </template>
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'FormField',
  props: {
    field: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    schoolList: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    shouldShow() {
      if (this.field.condition) {
        return this.field.condition(this.form)
      }
      return true
    },
  },

  methods: {
    updateValue(value) {
      this.$emit('input', { key: this.field.key, value })

      // For v-model support, update the form directly
      if (this.form && this.field.key) {
        this.$set(this.form, this.field.key, value)
      }
    },
  },
}
</script>

<style scoped>
.form-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}

.form-field--span-1 {
  grid-column: span 1;
}

.form-field--span-2 {
  grid-column: span 2;
}

.form-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #333;
}

.required-indicator {
  color: #e74c3c;
  margin-left: 2px;
}

.form-control {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s ease;
  color: #333;
}

.form-control:focus {
  outline: none;
  border-color: #426dff;
  box-shadow: 0 0 0 2px rgba(66, 109, 255, 0.2);
}

.form-control:readonly,
.form-control:disabled {
  background-color: #f8f9fa;
  color: #666;
  border-color: #e9ecef;
}

.form-field--required .form-control {
  border-left: 3px solid #e74c3c;
}

textarea.form-control {
  resize: vertical;
  min-height: 80px;
}
</style>
